import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[gsHeaderTooltip]'
})
export class GSHeaderTooltip {
    constructor(private element: ElementRef, private renderer: Renderer2) {
    }

    private _text;
    private container;
    private tooltipArrow;
    private tooltipTextContainer;
    private tooltipIcon;
    get showText() {
        return [undefined, ''].indexOf(this._text) == -1;
    }
    @Input('gsHeaderTooltip') set text(text: string) {
        this._text = text;
    }

    @Input() type = 'info';//options: info, warning and error, info is default
    @Input() showOnClick = false;//by default tooltip will be hiddine on click
    @Input() innerHTML = false;
    @Input() position = 'bottom';//options: bottom, right - default is bottom
    // Horizontal anchor for the default bottom position. 'mouse' (legacy)
    // places the tooltip at the cursor X; 'host' centres it under the host.
    @Input() anchor: 'mouse' | 'host' = 'mouse';

    @HostListener('mouseenter', ['$event'])
    show(e) {
        if (this.showText && !this.container) {
            this.removeTooltips();
            this.container = document.createElement('div');

            this.tooltipArrow = document.createElement('div');
            this.tooltipTextContainer = document.createElement('div');
            this.container.appendChild(this.tooltipArrow);

            // 'host' mode defers horizontal placement to getDirection; 'mouse' uses cursor X.
            if (this.anchor !== 'host') {
                if (window.innerWidth / 2 > e.clientX) {
                    this.renderer.setStyle(this.tooltipArrow, 'left', `${8}px`)
                    this.renderer.setStyle(this.container, 'left', `${e.clientX - 13}px`)
                }
                else {
                    this.renderer.setStyle(this.tooltipArrow, 'right', `${8}px`)
                    this.renderer.setStyle(this.container, 'right', `${window.innerWidth - e.clientX - 13}px`)
                }
            }
            this.setType();
            this.setText();
            this.renderer.appendChild(document.body, this.container);
            this.getDirection(this.element.nativeElement, e);

        }
        e.stopPropagation();
    }

    @HostListener('mouseleave', ['$event'])
    hide(e) {
        if (this.showText) {
            this.remove();
        }
    }

    @HostListener('mouseup', ['$event'])
    click(e) {
        if (!this.showOnClick)
            this.remove();
    }

    private remove() {
        if (this.container) {
            this.renderer.removeChild(document.body, this.container);
            this.container = undefined;
        }
    }

    private removeTooltips() {
        for (var i = document.body.children.length - 1; i > 0; i--) {
            if (document.body.children[i].className.indexOf('gs-tooltip') > -1)
                this.renderer.removeChild(document.body, document.body.children[i]);
        }
    }
    private getDirection(hostElem: HTMLElement, ev: MouseEvent) {
        this.renderer.removeClass(this.tooltipArrow, 'gs-tooltip-arrow-up');
        this.renderer.removeClass(this.tooltipArrow, 'gs-tooltip-arrow-down');
        this.renderer.removeClass(this.tooltipArrow, 'gs-tooltip-arrow-left');
        const rect = hostElem.getBoundingClientRect();
        
        if (this.position === 'right') {
            this.renderer.setStyle(this.container, 'top', `${rect.top}px`);
            this.renderer.setStyle(this.container, 'left', `${rect.right + 8}px`);
            this.renderer.removeStyle(this.container, 'right');
            // Reset arrow left/right positioning set by show() and position properly
            this.renderer.removeStyle(this.tooltipArrow, 'left');
            this.renderer.removeStyle(this.tooltipArrow, 'right');
        } else {
            this.renderer.addClass(this.tooltipArrow, 'gs-tooltip-arrow-up');
            this.renderer.setStyle(this.container, 'top', `${rect.bottom + 8}px`);

            if (this.anchor === 'host') {
                // Centre under the host, clamp to viewport, point arrow at host centre.
                const width = this.container.offsetWidth;
                const centerX = rect.left + rect.width / 2;
                let left = centerX - width / 2;
                left = Math.max(8, Math.min(left, window.innerWidth - width - 8));
                this.renderer.setStyle(this.container, 'left', `${left}px`);
                this.renderer.removeStyle(this.container, 'right');
                const arrowLeft = Math.max(10, Math.min(centerX - left - 10, width - 30));
                this.renderer.setStyle(this.tooltipArrow, 'left', `${arrowLeft}px`);
                this.renderer.removeStyle(this.tooltipArrow, 'right');
            }
        }
    }

    private setText() {
        this.renderer.addClass(this.tooltipTextContainer, 'gs-tooltip-container');
        let tooltipText = document.createElement('span');
        tooltipText.innerHTML = this._text;
        this.tooltipTextContainer.appendChild(tooltipText);
        this.container.appendChild(this.tooltipTextContainer);
    }

    private setIcon() {
        let tooltipIconContainer = document.createElement('span');
        this.tooltipIcon = document.createElement('i');
        this.renderer.appendChild(tooltipIconContainer, this.tooltipIcon);
        this.renderer.addClass(this.tooltipIcon, 'fas');
        this.renderer.setStyle(tooltipIconContainer, 'padding-right', '5px');
        switch (this.type) {
            case "info":
                this.renderer.addClass(this.tooltipIcon, 'fa-exclamation-circle');
                break;
            case "warning":
                this.renderer.addClass(this.tooltipIcon, 'fa-exclamation-circle');
                break;
            case "error":
                this.renderer.addClass(this.tooltipIcon, 'fa-exclamation-triangle');
                break;
        }
        this.renderer.appendChild(this.tooltipTextContainer, tooltipIconContainer);
    }

    private setType() {
        this.renderer.addClass(this.container, 'gs-tooltip');
        this.renderer.setStyle(this.container, 'font-size', '12px');
        this.renderer.setStyle(this.container, 'max-width', '500px');
        switch (this.type) {
            case "info":
                this.renderer.addClass(this.container, 'gs-tooltip-info');
                break;
            case "warning":
                this.renderer.addClass(this.container, 'gs-tooltip-warning');
                break;
            case "error":
                this.renderer.addClass(this.container, 'gs-tooltip-error');
                this.renderer.addClass(this.container, 'gs-tooltip-error');
                break;
        }
    }
}
